export default __webpack_public_path__ + "static/media/paulo-negri.77407b10.webp";